import { ApplicationRef } from '@angular/core';
import { RootRegistrationService } from '../root-registration-service';

const createCommand: any = injector => {
	const rootServices = injector.get(RootRegistrationService);
	const appRef = injector.get(ApplicationRef);

	return function closeActiveModal(payload: any) {
		const modalService = rootServices.get('ModalWindowsService');
		const activeModal = modalService.getActiveModal();
		if (activeModal) {
			activeModal.close();
			appRef.tick();
			return true;
		}
		return false;
	};
};

export default createCommand;
